/**
 * @deprecated Use `ControlType` and `Priority` enums instead.
 */
export enum Type {
  PRIMARY = 'primary',

  /**
   * @deprecated use
   */
  PAY = 'pay',
  SECONDARY = 'secondary',
  DANGER = 'danger',
  LINK = 'link',
}
